<template>
  <div>

    <xolas-table
       table-ref="progress-table"

       title="Progress"
       icon="fa fa-share-alt"

       hide-org-badge
       :show-search="false"

       :url="'/actions/site/' + rowData.id + '/null/prg'"

       :fields="fields"

     />

  </div>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'

export default {

  mixins: [DateMixins, NumberMixins],

  components: {
    XolasTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },




  data () {

    return {

      // Per-column min-widths in content ratios so el-table flexes to fill instead
      // of distributing every column equally; sum under the table width (XOL-231).
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id',
          minWidth: '50'
        },
        {
          name: 'actionType',
          title: 'Type',
          sortField: 'actionType',
          minWidth: '100'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '170'
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '110'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '140'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '150'
        }

      ]
    }

  }

}

</script>
